import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {RolePermission } from '../../shared/models/role.permission.enum';
import { QuoteService } from '../services/quote.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponent extends AbstractBiditComponent implements OnInit {

  customerId: number;
  
  constructor(private router: Router, private deviceDetectorService: DeviceDetectorService, private route: ActivatedRoute) {
    super(deviceDetectorService);
  }

  ngOnInit() {
    let canAdd = QuoteService.hasPermission(RolePermission.AddQuote);
    if (!canAdd) {
      this.router.navigate(['/quote/']);
    }

    this.route.queryParamMap.subscribe(params => {
      let strCustomerId = params.get('customerId');

      if (strCustomerId) {
        this.customerId = parseInt(strCustomerId);
      }
    });
  }
}
